import React, { Component } from "react";
import "./HighDeductiblePanel.component.css";
import DropDownSelect from "../../common/form-fields/drop-down/DropDownSelect";
import Helpers from "../../common/util/Helpers";

class HighDeductiblePanel extends Component {

    constructor(props) {
        super(props);

        this.state = {
            activePanel: "front",
        }
    }

    customizePlan() {
        this.setState({
            activePanel: "back"
        });
    }

    viewFront() {
        this.setState({
            activePanel: "front"
        });
    }

    renderCoinsurance() {

        let coinsuranceOptions = [];
        this.props.policyDetails.policies.map(policy => {
            if (policy.deductible >= 1500) {
                if (!coinsuranceOptions.find(ele => ele.value === policy.reimbursement*100)) {
                    let obj = { displayName: policy.reimbursement * 100 + "%", value: policy.reimbursement * 100 }
                    coinsuranceOptions.push(obj);
                }
            }
        });

        coinsuranceOptions.sort((op1, op2) => {
            if (op1.value > op2.value) return 1;
            return -1;
        })

        if (coinsuranceOptions.length >=2) {
            return (
                <DropDownSelect
                    style={{ width: "100%", backgroundColor: "#FFF" }}
                    field="high_deductible_coinsurance"
                    className=""
                    id="high_deductible_coinsurance"
                    data={coinsuranceOptions}
                    onChange={this.props.handleCoinsuranceChange.bind(this)}
                    initialValue={this.props.tempSelectedCoinsurance}
                />
            )
        } else if (coinsuranceOptions.length === 1) {
            return (
                <div className="text-left single-reimbursement-text">
                    <p>{coinsuranceOptions[0].displayName}</p>
                </div>
            )
        } else {
            return (
                <div className="text-left">
                    No coinsurance options available
                </div>
            )
        }
    }

    renderDeductible() {

        let deductibleOptions = [];
        this.props.policyDetails.policies.map(policy => {
            if (policy.deductible >= 1500) {
                if (!deductibleOptions.find(ele => ele.value === policy.deductible)) {
                    let obj = { displayName: "$" + policy.deductible, value: policy.deductible }
                    deductibleOptions.push(obj);
                }
            }
        });

        deductibleOptions.sort((op1, op2) => {
            if (op1.value > op2.value) return 1;
            return -1;
        })

        if (deductibleOptions.length >=2) {
            return (
                <DropDownSelect
                    style={{ width: "100%", backgroundColor: "#FFF" }}
                    field="high_deductible_deductible"
                    className=""
                    id="high_deductible_deductible"
                    data={deductibleOptions}
                    onChange={this.props.handleDeductibleChange.bind(this)}
                    initialValue={this.props.tempSelectedDeductible}
                />
            )
        } else if (deductibleOptions.length === 1) {
            return (
                <div className="text-left single-reimbursement-text">
                    <p>{deductibleOptions[0].displayName}</p>
                </div>
            )
        } else {
            return (
                <div className="text-center">
                    No deductible options available
                </div>
            )
        }
    }

    selectPlanType() {
        this.props.setSelectedPlanType("highdeductible");
        this.viewFront();
    }

    render() {
        return (
            <div className="high-deductible-panel mb-4">
                { this.state.activePanel === "front" && 
                <div id="highDedPanelFront" className={`row overflow-hidden high-deductible-panel-front ${this.props.selectedPlanType === "highdeductible" ? "selected" : ""}`}>
                    <div className="col text-center py-4 px-3 high-deductible-panel-front-content">
                        <h3 className="text-center font-weight-bold high-deductible-panel-front-title">Value Plan</h3>
                        <p className="text-center high-deductible-panel-front-description">
                        Signature coverage at a lower monthly cost. Protection when you need it, savings when you don’t. <span className="font-weight-bold">Higher deductibles mean lower monthly premiums</span>.
                        </p>
                        <div className="d-block px-3 py-2 high-deductible-panel-front-table">
                            <span className="font-weight-bold high-deductible-panel-front-table-title">{Helpers.formatCurrency(this.props.selectedPremium.replace(',', ''))}</span>/month
                            <table className="text-start high-deductible-panel-front-table-content">
                                <tr>
                                    <td>Reimbursement:</td>
                                    <td><span className="font-weight-bold">{this.props.selectedCoinsurance}%</span></td>
                                </tr>
                                <tr>
                                    <td>Annual Deductible:</td>
                                    <td><span className="font-weight-bold">${this.props.selectedDeductible}</span></td>
                                </tr>
                                <tr>
                                    <td>Maximum Payouts:</td>
                                    <td><span className="font-weight-bold">Unlimited</span></td>
                                </tr>
                            </table>
                            {/*
                            <div className="text-start">
                                <a type="button" className="text-start font-weight-bold high-deductible-panel-front-table-link">What do these terms mean?</a>
                            </div>
                            */}
                        </div>
                        <div className="mt-3 high-deductible-panel-front-table-content">
                            <a type="button" onClick={this.customizePlan.bind(this)} className="float-left buttonlink align-middle position-relative customize-plan" style={{ marginLeft: "2px" , textDecoration :"underline" , marginTop:"10px" }}>Customize Plan</a>
                            { this.props.selectedPlanType === "highdeductible" ? 
                                    (<button type="button" className="button-primary align-middle float-right button-plan-selected">Selected <img src="/assets/images/check-mark-white.png" className="ml-1 check-mark-white" /></button>) :
                                (<div onClick={this.selectPlanType.bind(this)} className="whiteBtn align-middle float-right">Select This Plan</div>)
                            }
                            <div className="clear-both"></div>
                        </div>
                    </div>
                </div>
                }
                { this.state.activePanel === "back" && 
                <div id="highDeductiblePanelBack" className="row overflow-hidden high-deductible-panel-back">
                    <div className="col text-center py-4 px-1 high-deductible-panel-back-content">
                        <h3 className="text-center mb-0 font-weight-bold high-deductible-panel-back-title">Customize the Value Plan</h3>
                        <p className="d-block mb-0 mt-0">
                            <span className="font-weight-bold high-deductible-panel-back-table-premium">{Helpers.formatCurrency(this.props.tempSelectedPremium.replace(',', ''))}</span>/month
                        </p>
                        <div className="d-block mx-auto mt-1 high-deductible-panel-back-table-options">
                            <h4 className="text-left mb-1 high-deductible-panel-back-table-title">Reimbursement Options</h4>
                            {
                                this.renderCoinsurance()
                            }
                            <h4 className="text-left mt-3 mb-1 high-deductible-panel-back-table-title">Deductible Options</h4>
                            {
                                this.renderDeductible()
                            }
                        </div>
                        <div className="mt-3 px-3 high-deductible-panel-back-table-content">
                            <a onClick={this.viewFront.bind(this)} className="back-link float-left mt-2">&lt; Back</a>
                                <div onClick={this.selectPlanType.bind(this)} className="whiteBtn align-middle float-right" >
                                Select This Plan
                            </div>
                        </div>
                    </div>
                </div>
                }
                {/*
                <div id="termMeaningsPanel" v-show="this.highDeductibleActivePanel == 'terms'" className="row overflow-hidden" style="border-color:#99E9CE;border-width:6px 1px 1px 1px;border-style:solid;border-bottom-left-radius:24px;min-height:386px;background-color:#DEDAD6;">
                    <div className="row pe-0 pt-3">
                        <div className="col pe-1">
                            <img v-on:click.stop="viewFront()" src="/Images/V3/funnel/modal-close.png" className="ms-1 float-end" style="height:18px;width:18px;cursor:pointer;" />
                        </div>
                    </div>
                    <img src="/Images/V3/funnel/modal-close.png" className="" style="height:18px;width:18px;right:0px;" />
                    <span className="fw-bold text-center mb-3" style="font-size:16px;">Pet Insurance Terms</span>
                    <p style="font-size:13px;">
                        <span className="fw-bold">REIMBURSEMENT</span>
                        What you'll get back from your claim after your annual deductible is met.  Unlike some pet insurance companies, Healthy Paws will reimburse you based on your actual vet bill, as opposed to
                        some plans that only reimburse based on what they think the treatment for a specific condition should cost.
                    </p>
                    <p style="font-size:13px;">
                        <span className="fw-bold">ANNUAL DEDUCTIBLE</span>
                        The amount you'll pay out-of-pocket each year before your plan begins to cover medical costs for your pet(s).
                    </p>
                    <p style="font-size:13px;">
                        <span className="fw-bold">MAXIMUM PAYOUT</span>
                        Unlike some pet insurance plans, the Healthy Paws plan has <span className="fw-bold">no limits on claim payouts per incident, per year or for the lifetime of the policy</span>.
                    </p>
                </div>
                */}
            </div>
        )
    }
}



export default HighDeductiblePanel;